import { memo } from "react";
import Ratings from "./Ratings";
import { ColorContainer } from ".";
import { useNavigate } from "react-router-dom";
import imageBuilder from "helpers/imageBuilder";

const DietCard = ({ data }) => {
  const {
    _id,
    title,
    categories,
    durationMethod,
    featuredImage,
    desc,
    price,
    rating,
  } = data;

  const navigate = useNavigate();

  const imageUrl = imageBuilder(featuredImage);
  return (
    <div
      className=" rounded overflow-hidden shadow-lg m-1 sm:m-2 md:m-4 cursor-pointer relative"
      onClick={() => navigate(`/diets/${_id}`)}
    >
      {price && (
        <div style={{ position: "absolute", left: "3px", top: "8px" }}>
          <ColorContainer title={"Premium"} />
        </div>
      )}

      <img
        className="w-full h-40 sm:48 object-cover"
        src={imageUrl}
        alt={title}
      />
      <div className="p-2 md:p-3 h-40 sm:h-48 lg:h-56 flex flex-col justify-between ">
        <h2 className="font-bold text-md line-clamp-1 sm:text-xlm sm:mb-2 text-gray-800 sm:line-clamp-2">
          {title}
        </h2>
        <p className="text-gray-700 text-[12px] sm:text-sm line-clamp-3">
          {desc}
        </p>

        <Ratings rating={rating} />

        <div className="flex items-center justify-between mt-2">
          <ColorContainer title={categories?.[0].title || "category"} />

          <span className="text-gray-700 text-[12px] sm:text-sm md:text-base whitespace-nowrap">{`${
            durationMethod?.duration || 10
          } minutes`}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(DietCard);
